
const baseUrl = 'https://job-portal-mern-mgpg.onrender.com';

export { baseUrl };